/** Loại thu treated as phí dịch vụ — hidden from Hoạt động thu filters/list. */
const SERVICE_FEE_STYLE_REVENUE_CODES = new Set(['T-SHC001', 'T-VL001']);

export const COMMUNITY_ROOM_FEE_STATISTICS_LABEL = 'Phí sử dụng phòng SHCĐ';

export function isExcludedFromActivityRevenueCategory(code: string): boolean {
  return SERVICE_FEE_STYLE_REVENUE_CODES.has(code.trim().toUpperCase());
}
